import { useEffect } from 'react';

import apiDocs from 'jsons/api_docs/imps.json';
import { useSetRecoilState } from 'recoil';
import { apiDocsState } from 'recoils/web/apiDocsState';

import { getApiDocs } from 'apis/etcApi';

/**
 * @desc 앱 시작 시 API 문서를 한 번 호출하여 Recoil 상태에 저장하는 커스텀 훅
 */
const useApiDocsLoader = () => {
  const setApiDocs = useSetRecoilState(apiDocsState);

  useEffect(() => {
    const fetchApiDocs = async () => {
      try {
        const data = await getApiDocs();
        setApiDocs(data);
      } catch (error) {
        setApiDocs(apiDocs);
      }
    };

    fetchApiDocs();
  }, [setApiDocs]);
};

export default useApiDocsLoader;
